export default __webpack_public_path__ + "static/media/3528.66c6a3e8.svg";